import React from "react";
import "./AddToCalendarModal.css";
import "bootstrap-icons/font/bootstrap-icons.css";
const AddToCalendarModal = ({ showModal, onClose, selectedSlot, onSelect }) => {
  if (!showModal) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered add-calendar-dialog">
          <div className="modal-content add-calendar-modal">
            {/* Header */}
            <div className="modal-header border-0 pb-0">
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body px-3 pt-0 pb-3">
              {/* Calendar Icon */}
              <div className="calendar-main-icon mx-auto">
                <i className="bi bi-calendar3"></i>
              </div>

              {/* Title */}
              <h5 className="text-center modal-title-custom">
                Add to calendar
              </h5>

              {/* Date */}
              <div className="text-center selected-date">
                <i className="bi bi-calendar3 me-1"></i>
                {selectedSlot?.date}
              </div>

              {/* Time */}
              <div className="text-center selected-time">
                {selectedSlot?.time}
              </div>

              {/* Appointment */}
              <button
                type="button"
                className="calendar-option w-100"
                onClick={() => onSelect("appointment")}
              >
                <div className="option-icon appointment-icon">
                  <i className="bi bi-calendar-event"></i>
                </div>

                <div className="option-content text-start">
                  <div className="option-title">Appointment</div>

                  <div className="option-description">
                    Book a customer in this time slot
                  </div>
                </div>

                <i className="bi bi-chevron-right option-arrow"></i>
              </button>

              {/* Unavailable */}
              <button
                type="button"
                className="calendar-option w-100 unavailable-option"
                onClick={() => onSelect("unavailability")}
              >
                <div className="option-icon unavailable-icon">
                  <i className="bi bi-lock-fill"></i>
                </div>

                <div className="option-content text-start">
                  <div className="option-title">Unavailability</div>

                  <div className="option-description">
                    Block this time (not available)
                  </div>
                </div>

                <i className="bi bi-chevron-right option-arrow"></i>
              </button>

              {/* Cancel */}
              <button
                type="button"
                className="btn cancel-btn w-100"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddToCalendarModal;
